import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from "vue";
import { loaderTabOptions } from "@/util";
import { projectStore } from "@/hooks";
import { TabList } from "@/components/common";
import { JobsTable } from "@/components/jobs";
import ProjectVersionStepper from "./ProjectVersionStepper.vue";


/**
 * Allows for loading created projects and versions, as well as viewing past project uploads.
 */
const __default__ = {
  name: "ProjectLoader",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const hasProject = computed(() => projectStore.projectId !== "");
const allTabs = loaderTabOptions();
const tabs = computed(() => (hasProject.value ? allTabs : allTabs.slice(0, 2)));
const tab = ref(tabs.value[0].id);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TabList), {
    modelValue: tab.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
    tabs: tabs.value
  }, _createSlots({
    load: _withCtx(() => [
      _createVNode(ProjectVersionStepper)
    ]),
    user: _withCtx(() => [
      _createVNode(_unref(JobsTable), { "display-project-jobs": false })
    ]),
    _: 2
  }, [
    (hasProject.value)
      ? {
          name: "project",
          fn: _withCtx(() => [
            _createVNode(_unref(JobsTable), { "display-project-jobs": true })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "tabs"]))
}
}

})